import { render, staticRenderFns } from "./newListePropositions.vue?vue&type=template&id=e56ce6e8&scoped=true&"
import script from "./newListePropositions.vue?vue&type=script&lang=js&"
export * from "./newListePropositions.vue?vue&type=script&lang=js&"
import style0 from "./newListePropositions.vue?vue&type=style&index=0&id=e56ce6e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ce6e8",
  null
  
)

export default component.exports